import React from 'react';
import Layout from '../../components/Layout/Layout';
import SkeletonCard from '../../components/SkeletonCard/SkeletonCard';
import styles from './SkeletonCardPage.module.css';

const SkeletonCardPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.cardStack}>
        <SkeletonCard
          size="Small"
          initialOpen={false}
          rotation={0}
        />
      </div>
    </Layout>
  );
};

export default SkeletonCardPage;